import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import de from './i18n/de';
import en from './i18n/en';
import es from './i18n/es';
import fr from './i18n/fr';
import it from './i18n/it';
import nl from './i18n/nl';
import pl from './i18n/pl';

i18n.use(initReactI18next).use(LngDetector).init({
	resources: {
		de: { translation: de },
		en: { translation: en },
		es: { translation: es },
		fr: { translation: fr },
		it: { translation: it },
		nl: { translation: nl },
		pl: { translation: pl }
	},
	fallbackLng: 'en',
	keySeparator: false,
	returnObjects: true,
	interpolation: {
		escapeValue: false
	},
	react: {
		wait: true
	}
});
